import React from 'react'
import { InputMessage } from '@dostavkee/web-ui'

import { CellRadioButton } from './cell-radio-button'
import styles from './cell-radio-group.module.scss'

export interface CellRadioComposition {
    Button: typeof CellRadioButton
}

export interface CellRadioGroupProps {
    children: React.ReactNode
    label?: string
    errorMessage?: string
    hint?: string | React.ReactNode
}

export const CellRadioGroup: React.FC<CellRadioGroupProps> & CellRadioComposition = ({
    label,
    children,
    errorMessage,
    hint,
}: CellRadioGroupProps) => {
    return (
        <fieldset className={styles['cell-radio-group']}>
            {label && <legend className={styles['cell-radio-group__label']}>{label}</legend>}
            {children}
            {errorMessage ? (
                <InputMessage variant='error'>{errorMessage}</InputMessage>
            ) : typeof hint === 'string' ? (
                <InputMessage variant='info'>{hint}</InputMessage>
            ) : (
                hint
            )}
        </fieldset>
    )
}

CellRadioGroup.displayName = 'CellRadioGroup'
CellRadioGroup.Button = CellRadioButton
